<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="io-view-page-title" class="mb-3">
              {{ informationObligation.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('information_obligation')">
                <GuideButton :guide="getGuide('information_obligation')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-io-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
                      class="btn btn-edit"
                      qid="edit-io-button"
                      @click="showEditIOModal(informationObligation)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.INFORMATION_OBLIGATION_DELETE, permissions.INFORMATION_OBLIGATION_DELETE_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
                      class="btn btn-delete"
                      qid="delete-io-button"
                      @click="showConfirmDeleteModal(informationObligation)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
                <span class="ml-2 text-muted small" qid="view-io-modified-date">
                {{ informationObligation.updated_at | formatDate }}
              </span>
              <Avatar v-if="informationObligation.updated_by" :object="informationObligation.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
                <span v-if="informationObligation.updated_by" qid="view-io-modified-by">
                {{ informationObligation.updated_by.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="content-view-body">
          <br>
          <div class="mt-3">
            <p class="text-dark">
              {{ $t('maintenance.information_obligation.create.description_label') }}
            </p>
            <hr>
            <p qid="io-description" class="text-formatted">
              {{ informationObligation.description }}
            </p>
            <br>
          </div>
          <div class="mt-2">
            <p class="text-dark">
              {{ $t('maintenance.information_obligation.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </p>
            <hr>
            <b-alert v-if="error.length"
                     show
                     variant="danger"
                     qid="attachments-io-error"
            >
              {{ error }}
            </b-alert>
            <p v-for="file in informationObligation.media">
              <button class="float-right btn btn-link btn-inline-icons"
                      @click="openDeleteAttachmentModal(file)"
                      v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
                      qid="remove-media-item"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a href="#" @click="downloadMedia(file)" qid="create-io-media-item">
                {{ file.file_name }}
              </a>
            </p>
            <label class="btn btn-secondary cursor-pointer"
                   qid="create-io-file-button"
                   v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
            >
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file"
                     @change="onFileChange"
                     @click="resetFile"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('system.upload') }}
              </span>
            </label>
            <br>
          </div>
          <div class="mt-4">
            <p class="text-dark">
              {{ $t('maintenance.information_obligation.create.links_label') }}
            </p>
            <hr>
            <div v-if="informationObligation.links">
              <p v-for="link in informationObligation.links" >
                <button class="float-right btn btn-link btn-inline-icons"
                        @click="openDeleteLinkModal(link)"
                        v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
                        qid="view-io-remove-link"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
                <a :href="link.url" target="_blank" qid="create-io-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
            <div v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))">
              <div v-if="showInput">
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLink"
                  :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                  qid="create-p-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLinkName"
                  :placeholder="inputLink ? inputLink : $t('table.name')"
                  qid="create-p-links"
                ></b-form-input>
                <div class="text-right mt-2">
                  <span class="btn btn-success cursor-pointer mr-0"
                        id="inputGroup"
                        @click="handleLink"
                        qid="handle-link-save"
                  >
                    {{ $t('system.save') }}
                  </span>
                </div>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer"
                  @click="showInput = true"
                  v-if="isGranted([permissions.INFORMATION_OBLIGATION_EDIT, permissions.INFORMATION_OBLIGATION_EDIT_OWN], informationObligation.created_by) && (!getClient.parent || (getClient.parent && informationObligation.partition))"
                  qid="add-another-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
            </span>
            <br>
          </div>
        </div>
      </div>
    </div>


    <!-- Edit information obligation modal template -->
    <b-modal ref="edit-information-obligation" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-io-title">
          {{ $t('maintenance.information_obligation.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-io-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editIOFormSubmit" qid="create-io-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-io-name-label">
              {{ $t('maintenance.information_obligation.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-io-form-name"
              type="text"
              v-model="ioForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.information_obligation.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-io-description-label">
              {{ $t('maintenance.information_obligation.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-io-form-description"
              v-model="ioForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.information_obligation.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditIOModal"
                    qid="edit-io-cancel-button"
          >
            {{ $t('maintenance.information_obligation.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-io-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.information_obligation.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete information obligation confirm modal template -->
    <b-modal ref="delete-information-obligation" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-io-title">
          {{ $t('maintenance.information_obligation.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.information_obligation.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.information_obligation.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-io-cancel-button"
        >
          {{ $t('maintenance.information_obligation.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteIO(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-io-submit-button"
                  v-if="isGranted([permissions.INFORMATION_OBLIGATION_DELETE, permissions.INFORMATION_OBLIGATION_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.information_obligation.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
import {initialsAvatarUrl} from '@/util/userAvatar.js';
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'InformationObligationView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.information_obligation.title'),
          to: '/maintenance/information-obligation'
        }
      ],
      informationObligation: {},
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      itemToDelete: {},
      ioForm: {
        name: '',
        description: '',
        client:'',
      },
      error: '',
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
    }
  },
  computed: {
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      }
    }
  },
  components: {
    Avatar,
    ConfirmRemoveAttachment,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/information-obligation')
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    resetFile() {
      let imagefile = document.querySelector('#file');
      imagefile.value = '';
    },
    openDeleteAttachmentModal(object) {
      this.selectedFile = object
      this.showDeleteAttachmentModal = true
    },
    closeDeleteAttachmentModal () {
      this.selectedFile = {}
      this.showDeleteAttachmentModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    openDeleteLinkModal(object) {
      this.selectedLink = object
      this.showDeleteLinkModal = true
    },
    closeDeleteLinkModal () {
      this.selectedLink = {}
      this.showDeleteLinkModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    loadContent() {
      let self = this;
      piincHttp.get('information-obligations/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.informationObligation = response.data;
        // Push Information obligation name in breadcrumb array
        self.breadcrumbItems.push({text: self.informationObligation.name, active: true});
      }, function() {});
    },
    updateValidation(validation) {
      // Event emmited from validation component, update active validation
      this.informationObligation.validation = validation
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("model_type", this.informationObligation.who_am_i);
      formData.append("model_id", this.informationObligation.id);

      piincHttp.post('links', formData).then(function() {
        // Remove last item in breadcrumbs, because it will be added again on load content
        self.breadcrumbItems.pop();
        self.$toastr('success', self.$t('maintenance.information_obligation.link_add_success'))
        self.loadContent()
        self.inputLink = ''
        self.inputLinkName = ''
        self.showInput = false
      }, function() {})
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    onFileChange(file) {
      let files = file.target.files;
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      for (var i = 0; i < files.length; i++) {
        // Equal to 10 MB
        if (files[i].size > 10485760) {
          sizeError = true;
        }
        formData.append('document[]', files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.informationObligation.who_am_i);
      formData.append("model_id", this.informationObligation.id);

      if (sizeError) {
        this.error = this.$t('system.file_size')
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function() {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.$toastr('success', self.$t('maintenance.information_obligation.media_add_success'))
          self.error = ''
          self.loadContent()
        }, function(error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0]
          }
        })
      }
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return initialsAvatarUrl(user);
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-information-obligation'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-information-obligation'].hide()
    },
    confirmDeleteIO(object) {
      let self = this;
      piincHttp.delete('information-obligations/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.information_obligation.delete.success'))
      }, function() {});
    },
    showEditIOModal(object) {
      this.ioForm.slug = object.slug;
      this.ioForm.name = object.name;
      this.ioForm.description = object.description;
      this.$refs['edit-information-obligation'].show()
    },
    hideEditIOModal() {
      this.$refs['edit-information-obligation'].hide()
    },
    editIOFormSubmit(evt) {
      this.buttonDisabled = true;
      var moment = require('moment');
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.ioForm.client = this.getClient.slug;

      piincHttp.put('information-obligations/' + this.ioForm.slug, this.ioForm).then(function(response) {
        self.hideEditIOModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.informationObligation.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.information_obligation.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.information_obligation.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    }
  },
  created () {
    this.loadContent()
    this.loadGuides('information_obligation');
  }
}
</script>
